import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { createBrowserHistory } from "history";
import { REACT_APP_APPINSIGHTS_KEY, REACT_APP_DISABLE_TELEMETRY } from "$services/env";

const PLACEHOLDER_KEY = "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxxx";

export const isValidAppInsightsKey = (key) => {
    if (!key) return false;
    const trimmed = key.trim();
    if (!trimmed) return false;
    if (trimmed.includes("{")) return false;
    if (trimmed === PLACEHOLDER_KEY) return false;
    return true;
};

const browserHistory = createBrowserHistory({ basename: "" });
var reactPlugin = new ReactPlugin();
var appInsights = new ApplicationInsights({
    config: {
        instrumentationKey: REACT_APP_APPINSIGHTS_KEY || PLACEHOLDER_KEY,
        enableAutoRouteTracking: true,
        extensions: [reactPlugin],
        extensionConfig: {
            [reactPlugin.identifier]: { history: browserHistory },
        },
        disableTelemetry: !isValidAppInsightsKey(REACT_APP_APPINSIGHTS_KEY) || REACT_APP_DISABLE_TELEMETRY,
    },
});
appInsights.loadAppInsights();

export { reactPlugin, appInsights };
